import { render, staticRenderFns } from "./capacity.vue?vue&type=template&id=6ca25fe1&scoped=true"
import script from "./capacity.vue?vue&type=script&lang=ts"
export * from "./capacity.vue?vue&type=script&lang=ts"
import style0 from "./capacity.vue?vue&type=style&index=0&id=6ca25fe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca25fe1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
